<div class="row resourcesSection">
    <!-- <div class="col-6">
        <div class="row">
            <div class="col-12">
                <div class="userGuidanceDiv">
                    <div class="userGuidanceImg mb-2">
                        <img src="../../../assets/images/youtubelink.png" alt=""/>
                    </div>
                    <div class="userGuidanceHeader mb-3">
                        <span *ngIf="!isArabic">User Guidance Video</span>
                        <span *ngIf="isArabic">فيديو إرشادات المستخدم</span>
                    </div>
                    <div class="userGuidanceUrl">
                        <div class="urlDiv">
                            <p>
                                <span *ngIf="!isArabic">For Arabic Version,</span>
                                <span *ngIf="isArabic">للنسخة العربية ،</span>
                            </p>
                            <a href="https://www.youtube.com/embed/F4aNvkh2RR4" target="_blank">
                                <span *ngIf="!isArabic">Click Here</span>
                                <span *ngIf="isArabic">انقر هنا</span>
                            </a>
                        </div>
                        <div class="urlDiv">
                            <p>
                                <span *ngIf="!isArabic">For English Version,</span>
                                <span *ngIf="isArabic">للنسخة الإنجليزية ،</span>
                            </p>
                            <a href="https://www.youtube.com/embed/F4aNvkh2RR4" target="_blank">
                                <span *ngIf="!isArabic">Click Here</span>
                                <span *ngIf="isArabic">انقر هنا</span>
                            </a>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        
    </div> -->
    <div class="offset-3 col-6">
        <div class="row">
            <div class="col-12">
                <div class="userGuidanceDiv">
                    <div class="userGuidanceImg mb-2">
                        <img src="../../../assets/images/user-guidance.svg" alt=""/>
                    </div>
                    <div class="userGuidanceHeader">
                        <span *ngIf="!isArabic">User Guidance Document</span>
                        <span *ngIf="isArabic">دليل إرشادات المستخدم</span>
                    </div>
                    <div class="userGuidanceUrl">
                        <!-- <div class="urlDiv">
                            <p>
                                <span *ngIf="!isArabic">For Arabic Version,</span>
                                <span *ngIf="isArabic">للنسخة العربية ،</span>
                            </p>
                            <p (click)="fetchUserGuidance(true)">
                                <span *ngIf="!isArabic">Click Here</span>
                                <span *ngIf="isArabic">انقر هنا</span>
                            </p>
                        </div> -->
                        <div class="urlDiv">
                            <p>
                                <span class="font-radikal-light me-1" *ngIf="!isArabic">For English Version.</span>
                                <span class="font-radikal-light me-1" *ngIf="isArabic">للنسخة الإنجليزية ،</span>
                            </p>
                            <p (click)="fetchUserGuidance(false)">
                                <span *ngIf="!isArabic">Click Here</span>
                                <span *ngIf="isArabic">اضغط هنا</span>
                            </p>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>
